//classFlag為數字的class呼叫clearAllNumIdHeadStyleTags會被清除
function getHtmlMoveStyleToClass(htmlStr, classFlag) {
    return getHtmlMoveStyleToClassByReg(htmlStr, classFlag);
}

function getHtmlMoveStyleToClassByReg(htmlStr, classFlag) {
    let classIdx = 0;
    const stylesMap = {};
    // 用正則找所有 style 屬性
    htmlStr = htmlStr.replace(/(<[^>]+?)\sstyle="([^"]*)"(.*?>)/g, (match, beforeTag, style, afterTag) => {
        let className = stylesMap[style];
        if (!className) {
            className = `auto-style-${classFlag}-${classIdx++}`;
            stylesMap[style] = className;
        }
        // 檢查原本有沒有 class 屬性
        const classMatch = (beforeTag + afterTag).match(/class="([^"]*)"/);
        if (classMatch) {
            // 原本有 class，合併新 class
            const originalClass = classMatch[1];
            // 移除原本的 class 屬性
            let tag = (beforeTag + afterTag).replace(/class="[^"]*"/, '');
            // 移除 style 屬性
            tag = tag.replace(/style="[^"]*"/, '');
            // 加上合併後的 class
            return `${tag.replace(/>/, ` class="${originalClass} ${className}">`)}`;
        } else {
            // 原本沒有 class
            let tag = (beforeTag + afterTag).replace(/style="[^"]*"/, '');
            return `${tag.replace(/>/, ` class="${className}">`)}`;
        }
    });

    // 產生 CSS 字串
    let css = '';
    Object.entries(stylesMap).forEach(([style, className]) => {
        // 將 style 拆成各屬性
        const styleArr = style.split(';').map(s => s.trim()).filter(s => s);
        let cssProps = styleArr.map(prop => {
            // 只對 color 屬性加 !important
            if (prop.startsWith('color:') || prop.startsWith('font-weight:')) {
                return `${prop} !important`;
            }
            return prop;
        }).join('; ');
        css += `.${className} { ${cssProps} }\n`;
    });

    if (css!='') {
        // 動態插入 style
        appendStyle(css, classFlag);
    }

    return htmlStr;
}

function clearAllNumIdHeadStyleTags() {
    document.head.querySelectorAll('style[data-auto-style]').forEach(tag => {
        const attr = tag.getAttribute('data-auto-style');
        // 如果是純數字（只包含 0-9），就刪除
        if (/^\d+$/.test(attr)) {
            tag.remove();
        }
    });
}

function appendStyle(css, classFlag) {
    document.head.querySelectorAll(`style[data-auto-style="${classFlag}"]`).forEach(tag => tag.remove());
    const style = document.createElement('style');
    style.setAttribute('data-auto-style', classFlag); // 用 classFlag 標記
    // 加 CSP nonce
    const cspNonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');
    if (cspNonce) style.setAttribute('nonce', cspNonce);
    style.appendChild(document.createTextNode(css));
    //style.appendChild(document.createTextNode(css.replace(/;/g, ' !important;')));
    document.head.appendChild(style);
}

function processContent(contentArr, getClassFlag) {
    return contentArr.map(item => ({
        ...item,
        content: typeof getClassFlag === 'function'
            ? getHtmlMoveStyleToClass(item.content, getClassFlag(item))
            : getHtmlMoveStyleToClass(item.content, getClassFlag)
    }));
}

export default {
    getHtmlMoveStyleToClass,
    clearAllNumIdHeadStyleTags,
    processContent,
    appendStyle
};